<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{header}} </div>
        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <frg-form-input label="Libelle" id="libelle" type="text" placeholder="Ex: Groupement 1"
                            [formGroup]="formGroup" [control]="formGroup.get('libelle')" class="patient-form-input"
                            required="true" ></frg-form-input>
                <div class="button-wrapper"> 
                    <frg-button (activated)="closeRechercheModal()" [backgroundColor]="'var(--darkest-primary)'"
                        [type]="'reset'">Quitter</frg-button>
                    <frg-button *ngIf="!isEdit" [type]="'submit'">Ajouter
                    </frg-button>
                    <frg-button *ngIf="isEdit" [type]="'submit'">Modifier
                    </frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>